<template>
  <PopModal ref="modal" :title="goods && goods.name?$t('有关此产品的任何查询'):$t('给商家留言')">
    <van-form @submit="onClickSend">
      <div class="modal-body gry-bg px-3 pt-3">
        <div v-if="goods && goods.name" class="form-group">
          <input
            :placeholder="$t('产品名称')"
            :value="goods.name"
            class="form-control mb-3"
            disabled
            name="title"
            required=""
            type="text"
          />
        </div>
        <div class="form-group">
          <van-field
            v-model="consultContent"
            :label="$t('留言')"
            :placeholder="$t('请输入留言')"
            :rules="[
              {
                required: true
              }
            ]"
            autosize
            maxlength="1500"
            rows="3"
            show-word-limit
            type="textarea"
          ></van-field>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-outline-primary fw-600"
          data-dismiss="modal"
          type="button"
          @click="onClickCancel"
        >
          {{ $t("取消") }}
        </button>
        <van-button
          :loading="loading"
          :loading-text="$t('submitting')"
          class="btn btn-primary fw-600"
          native-type="submit"
          type="primary"
        >
          {{ $t("submit") }}
        </van-button>
      </div>
    </van-form>
  </PopModal>
</template>
<script>
import PopModal from "@/components/PopModal.vue";

export default {
  data() {
    return {
      loading: false,
      goods: {},
      shopUserId: null,
      consultContent: ""
    };
  },
  components: {
    PopModal
  },
  methods: {
    show(goods, shopUserId) {
      this.goods = goods;
      this.shopUserId = shopUserId;
      this.$refs.modal.show();
    },
    onClickCancel() {
      this.$refs.modal.hide();
    },
    onClickSend() {
      this.loading = true;
      this.$post("/user/chatGroupRecord/save", {
        content: this.consultContent,
        businessDataJson: JSON.stringify({ goodsId: this.goods && this.goods.id }),
        initGroupOtherUserId: this.shopUserId,
      })
        .then(() => {
          this.consultContent = null;
          this.$refs.modal.hide();
          this.$toast.success(this.$t("Commit_Success"));
          this.jump('/user/conversations')
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
